var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showNavbarHeader()
    ? _c("div", { staticClass: "navbar-header" }, [
        _c("div", { staticClass: "navbar-header-inner" }, [
          _c(
            "a",
            {
              staticClass: "close",
              on: {
                click: function($event) {
                  return _vm.hideNavbarBanner()
                }
              }
            },
            [_c("i", { staticClass: "fas fa-times" })]
          ),
          _vm._v(" "),
          _vm._m(0)
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top-box-header-body" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("h5", [
              _vm._v(
                "\n                            JETZT NEU!\n                        "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row first" }, [
          _c("div", { staticClass: "col-md-12 col-sm-12 col-xs-12 box" }, [
            _c("p", [
              _vm._v(
                "\n                            Kostenfreie Stornierungsmöglichkeit bis 14 Tage vor Anreise   "
              ),
              _c("span", [
                _vm._v(
                  "für Aufenthalte bis\n                        zum 31. März 2023*"
                )
              ])
            ]),
            _vm._v(" "),
            _c("h6", [
              _vm._v(
                "\n                            *nur gültig für Buchungen nach dem 03.09.2022\n                        "
              )
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }